import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

const MAX_REASON = 500;

interface RejectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason: string | undefined) => void;
  isPending?: boolean;
  eventSubject?: string;
}

export function RejectDialog({
  open,
  onOpenChange,
  onConfirm,
  isPending = false,
  eventSubject,
}: RejectDialogProps) {
  const [reason, setReason] = useState("");

  // Clear the textarea whenever the dialog is (re)opened so stale text from
  // a previous card doesn't leak into the next rejection.
  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const remaining = MAX_REASON - reason.length;
  const trimmed = reason.trim();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Rifiuta evento</DialogTitle>
          <DialogDescription>
            {eventSubject
              ? `L'evento "${eventSubject}" sara' marcato come IGNORATO.`
              : "L'evento sara' marcato come IGNORATO."}{" "}
            Puoi aggiungere una nota (opzionale).
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Textarea
            value={reason}
            onChange={(e) => setReason(e.target.value.slice(0, MAX_REASON))}
            placeholder="Motivo del rifiuto (opzionale)"
            rows={4}
            autoFocus
            disabled={isPending}
          />
          <div
            className={
              remaining < 0
                ? "text-right text-xs text-destructive"
                : "text-right text-xs text-muted-foreground"
            }
          >
            {remaining} caratteri rimasti
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            Annulla
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={() => onConfirm(trimmed.length > 0 ? trimmed : undefined)}
            disabled={isPending}
          >
            {isPending ? "Rifiuto..." : "Conferma rifiuto"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
